import { useForm } from "react-hook-form";
import TextField from "../../../ui/TextField";
import RangeField from "../../../ui/RangeField";
import SearchCondition from "../../../features/SearchCondition";
import Button from "../../../ui/Button";
import Summary from "../../../ui/Summary";
import styles from "../../../layout/admin/Main.module.scss";
import { validateMaxlength } from "../../../../utils/validate";

const StudentModalSearchFrom = ({ setSearchCondition }) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const resetCondition = () => {
    setValue("login_id", "");
    setValue("name", "");
    setValue("name_kana", "");
    setValue("street_name1", "");
    setValue("street_name2", "");
    setValue("birthday_s", "");
    setValue("birthday_e", "");
  };

  const onSubmit = (data) => {
    setSearchCondition(data);
  };

  return (
    <div>
      <details open>
        <Summary />
        <form onSubmit={handleSubmit(onSubmit)}>
          <SearchCondition title="学生を絞り込む">
            <table>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(8),
                  }}
                  name="login_id"
                  errors={errors}
                  label="学生番号(8桁)"
                  placeholder="学生番号(8桁)"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="name"
                  errors={errors}
                  label="氏名"
                  placeholder="氏名"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="name_kana"
                  errors={errors}
                  label="フリガナ"
                  placeholder="フリガナ"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="street_name1"
                  errors={errors}
                  label="町名"
                  placeholder="町名"
                ></TextField>
              </tr>
              <tr>
                <TextField
                  register={register}
                  validation={{
                    ...validateMaxlength(100),
                  }}
                  name="street_name2"
                  errors={errors}
                  label="丁名"
                  placeholder="丁名"
                ></TextField>
              </tr>
              <tr>
                <RangeField
                  type="date"
                  register={register}
                  nameTo={"birthday_e"}
                  nameFrom={"birthday_s"}
                  errors={errors}
                  label="生年月日"
                ></RangeField>
              </tr>
            </table>

            {errors.exampleRequired && <span>This field is required</span>}
          </SearchCondition>
          <div className={styles.buttonbox}>
            <Button type="submit" styleType="search">
              検索
            </Button>
            <Button
              type="button"
              styleType="back"
              onClick={() => resetCondition()}
            >
              条件クリア
            </Button>
          </div>
        </form>
      </details>
    </div>
  );
};

export default StudentModalSearchFrom;
